module.exports = __webpack_public_path__ + "img/news3-3.9f0f311f.png";